import { Grid, makeStyles } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import RoundedButton from '../../../components_v1/Actions/RoundedButton';
import InputSelect from '../../../components_v1/Forms/InputSelect';
import SimpleModal from '../../../components_v1/Structure/Modals/SimpleModal';
import DisplayText from '../../../components_v1/Texts/DisplayText';
import { isFormValid, onGetCatalogs, onSetErrorsToForm } from '../../../shared/utility';
import { request_responsibles } from './requests';

const useStyles = makeStyles(theme => ({
    form:{
        paddingTop:32,
        paddingBottom:32
    }
}))

const ResponsibleFilterModal = (props) => {

    const classes = useStyles()
    const { open, onClose, onRequestUsers, history, onAddFilter } = props
    const [form, setForm] = useState(JSON.parse(JSON.stringify(formData)))
    const [file, setFile] = useState(null)
    const [users, setUsers] = useState([])
    const [services, setServices] = useState([])
    const [supervisors, setSupervisors] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [inputValue, setInputValue] = useState('')

    useEffect(() => {
        if (!open) {
            setForm(JSON.parse(JSON.stringify(formData)))
            setError(''); setLoading(false); setUsers([]); setInputValue('')
        }
    }, [open])

    const onChange = (data) => {
        let temp = { ...form }
        const id = data.config.id
        temp[id] = { ...data }
        console.log('Hay cambio')
        if(id === 'user_id'){
            const new_value = data.value
            const elementFound = data.options.find(el => el.value === new_value)
            if(elementFound){setInputValue(elementFound.label)}else{setInputValue('')}
        }
        setForm(temp)
    }

    const onCloseInput = (data) => {
        console.log('on menu closed')
        const _value = data.value
        if(data.options.length === 0){
            let temp = { ...form }
            const id = data.config.id
            temp[id] = { ...data, value:null, isValid:false, isVisited:true }
            setInputValue('')
            setForm(temp)
        }
    }

    const onSearchUsers = async(e) => {
        if(!e || e.target.value === 0){
            return
        }
        setInputValue(e.target.value)
        try {
            const _users = await request_responsibles(e.target.value)
            const _user_catalog = onGetCatalogs(_users, 'user_id', 'user')
            setUsers(_user_catalog)
        } catch (error) {
            console.log(error)
        }
    }

    const onSubmit = async () => {
        const errors = isFormValid(form)
        /// Check if the form is valid
        if(errors && errors.length){
            const new_form = onSetErrorsToForm(form, errors)
            setForm(new_form)
            return
        }

        const data2send = users.find(el => el.value === form.user_id.value)

        onAddFilter(data2send, 'responsible')
        onClose()

    }

    // Update catalogs in real time 
    let business_form = {...form.user_id}
    business_form.options = [...users]

    return ( 
        <SimpleModal open={open} onClose={onClose} maxWidth='sm' padding='small'>
            <div>
                <div className={classes.form}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <DisplayText variant='subtitle1'>Seleccione un usuario</DisplayText>
                            <InputSelect data={business_form} onChange={onChange} onInputChange={onSearchUsers} inputValue={inputValue} onClose={onCloseInput}/>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container justify='flex-end'>
                                <Grid item><RoundedButton onClick={onSubmit} >Seleccionar</RoundedButton></Grid>
                            </Grid>
                        </Grid>
                    
                    </Grid>
                </div>
            </div>
        </SimpleModal>
     );
}
 
export default ResponsibleFilterModal;

const formData = {
    user_id: {
        value: '',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        options:[],
        config: {
            id: 'user_id',
            type: 'select',
            fullWidth: true,
            label: '',
            placeholder:'Seleccione una opción',
            helper: 'Este campo es requerido'
        },
        rules: {type: 'select'}
    },
    
}